export default __webpack_public_path__ + "static/measuring-18c726b4477f28bd1dced16d98829a5f.png";